// /home/szymon/kreator2/frontend/src/components/RebusesPanel.js
// v2.3.2 – Ostateczna próba poprawy URL na publiczny i usunięcia funkcji admina

import React, { useState, useEffect } from 'react';

export default function RebusesPanel({ backendUrl, onRebusFakeDndStart, publicMode }) {
  const [rebuses, setRebuses] = useState([]);
  const [error, setError] = useState('');
  const [searchTerm, setSearchTerm] = useState('');
  const [loadingRebuses, setLoadingRebuses] = useState(false);
  // Usunięto stan isDragging

  // Ładowanie listy rebusów
  useEffect(() => {
    if (backendUrl) {
      fetchRebuses();
    } else {
      setError('Brak adresu URL backendu.');
      console.error("[RebusesPanel] Backend URL is missing!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backendUrl]); // Zależność tylko od backendUrl

  const fetchRebuses = () => {
    setLoadingRebuses(true);
    setError('');
    // Używamy ZAWSZE publicznego endpointu /public/rebuses
    const fetchUrl = `${backendUrl}/public/rebuses`;
    console.log(`[RebusesPanel] Fetching from public endpoint: ${fetchUrl}`);

    fetch(fetchUrl) // Bez credentials
      .then((res) => {
        console.log(`[RebusesPanel] Response status: ${res.status}`);
        if (!res.ok) {
          return res.text().then(text => {
             console.error(`[RebusesPanel] Fetch error response text: ${text}`);
             // Rzucamy bardziej szczegółowy błąd
             throw new Error(`Błąd ${res.status} (${res.statusText}) pobierania listy rebusów z ${fetchUrl}`);
          });
        }
        return res.json();
      })
      .then((data) => {
        console.log(`[RebusesPanel] Received data:`, data);
        // Sprawdzamy czy data.rebuses istnieje i jest tablicą (na podstawie poprzedniego kodu kontrolera)
        setRebuses(Array.isArray(data.rebuses) ? data.rebuses : (Array.isArray(data) ? data : []));
        if (!Array.isArray(data) && !Array.isArray(data.rebuses)) {
            console.warn("[RebusesPanel] Received data is not an array:", data);
        }
      })
      .catch((err) => {
        console.error('[fetchRebuses] Fetch Error:', err);
        setError(`Nie udało się pobrać rebusów: ${err.message}`);
      })
      .finally(() => {
        setLoadingRebuses(false);
      });
  };

  // Funkcje drag & drop
  const handleFakeRebusDragStart = (rebus) => {
    if (onRebusFakeDndStart) {
      // Używamy public/raw-file dla URL obrazka SVG
      const imageUrl = `${backendUrl}/public/raw-file?path=${encodeURIComponent(rebus.svgPath)}`;
      console.log(`[RebusesPanel] handleFakeRebusDragStart: ID=${rebus.id}, URL=${imageUrl}`);
      onRebusFakeDndStart({
        id: rebus.id,
        url: imageUrl,
        width: rebus.defaultWidth || 100,
        height: rebus.defaultHeight || 100
      });
    }
  };

  // Usunięto handleDragStart i handleDragEnd

  // Filtrowanie rebusów po nazwie
  const filteredRebuses = rebuses.filter((r) =>
    r.name && r.name.toLowerCase().includes(searchTerm.toLowerCase()) // Dodano sprawdzenie czy r.name istnieje
  );

  // Renderowanie listy rebusów
  // Usunięto warunek !isDragging
  const rebusItems = filteredRebuses.map((rebus) => (
    <div
      key={rebus.id}
      className="rebus-item"
      // Usunięto draggable, onDragStart, onDragEnd
      onClick={() => handleFakeRebusDragStart(rebus)}
      style={{
        cursor: 'pointer', // Zmieniono na 'pointer' zamiast 'grab' dla spójności z onClick
        border: '1px solid #ddd',
        borderRadius: '4px',
        margin: '4px',
        padding: '2px',
        textAlign: 'center',
        overflow: 'hidden' // Zapobiega wychodzeniu treści poza div
      }}
      title={rebus.name}
    >
      <div style={{
         fontSize: '10px',
         marginBottom: '2px',
         fontWeight: 'bold',
         whiteSpace: 'nowrap',
         overflow: 'hidden',
         textOverflow: 'ellipsis',
         padding: '0 2px' // Dodano padding, aby tekst nie dotykał krawędzi
       }}>
        {rebus.name || 'Brak nazwy'} {/* Dodano fallback */}
      </div>
      <img
        // Używamy public/raw-file dla podglądu, fallback na svgPath
        src={`${backendUrl}/public/raw-file?path=${encodeURIComponent(rebus.previewPath || rebus.svgPath)}`}
        alt={rebus.name || 'Rebus'}
        style={{ maxWidth: '90%', maxHeight: '50px', display: 'block', margin: 'auto', objectFit: 'contain' }} // objectFit contain
        onError={(e) => { e.target.style.display = 'none'; }}
      />
    </div>
  ));


  return (
    <div className="rebus-panel-container" style={{ padding: '10px' }}>
      <h3>Lista Rebusów</h3>
      {error && <p className="dashboard-error" style={{ color: 'red', wordBreak: 'break-word' }}>{error}</p>}

      <div className="rebus-search" style={{ marginBottom: '15px' }}>
        <label htmlFor="rebusSearch" style={{ marginRight: '5px' }}>Wyszukaj:</label>
        <input
          id="rebusSearch"
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Nazwa rebusu..."
          className="rebus-input"
          style={{ padding: '8px', borderRadius: '4px', border: '1px solid #ddd', width: 'calc(100% - 80px)' }} // Poprawiono szerokość
        />
      </div>

      {/* Usunięto funkcje administracyjne */}

      {loadingRebuses ? (
         <div style={{ textAlign: 'center', padding: '20px' }}>Ładowanie rebusów...</div>
      ) : !Array.isArray(rebuses) ? ( // Dodatkowe sprawdzenie czy rebuses to tablica
         <p style={{ marginTop: '15px', textAlign: 'center', color: 'orange' }}>
            Otrzymano nieprawidłowe dane rebusów.
         </p>
      ) : filteredRebuses.length === 0 ? (
        <p style={{ marginTop: '15px', textAlign: 'center' }}>
          {searchTerm ? `Brak rebusów pasujących do wyszukiwania: "${searchTerm}"` : (rebuses.length === 0 ? 'Brak dostępnych rebusów.' : 'Brak pasujących rebusów.')}
        </p>
      ) : (
         <div className="rebuses-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
            gap: '10px',
            maxHeight: 'calc(100vh - 250px)', // Dostosowanie wysokości do okna
            overflowY: 'auto',
            border: '1px solid #eee',
            padding: '10px',
            marginTop: '15px'
         }}>
            {rebusItems}
         </div>
      )}
    </div>
  );
}
